import React from "react";
import SignableDocumentsTablePage from "../components/WorkshopPlanning/General/SignableDocuments/SignableDocumentsTablePage";
import { RestrictedRoute } from "../utils/RestrictedRoute";
import { Route, Switch } from "react-router";
import SignableDocumentsCreation from "../components/WorkshopPlanning/General/SignableDocuments/SignableDocumentsCreation";

export default function SignableDocumentsRouting(props) {
  const { currentIdentity, resources } = props;

  return (
    <>
      <RestrictedRoute
        resources={resources}
        path="/signabledocuments"
        exact
        routePermissions={[]}
        render={() => {
          return (
            <SignableDocumentsTablePage
              resources={resources}
              accessibleMoboOutlets={currentIdentity.accessibleMoboOutlets}
            />
          );
        }}
      />

      <Switch>
        <Route
          exact
          path="/signabledocuments/new"
          render={() => (
            <SignableDocumentsCreation
              resources={resources}
              defaultObjectType={currentIdentity.objectType}
              language={currentIdentity.languageCode}
              accessibleMoboOutlets={currentIdentity.accessibleMoboOutlets}
              dealerGroupId={currentIdentity.moboDealerGroupId}
            />
          )}
        />
        <Route
          path="/signabledocuments/:documentId"
          render={() => (
            <SignableDocumentsCreation
              resources={resources}
              defaultObjectType={currentIdentity.objectType}
              language={currentIdentity.culture.slice(0, 2)}
              accessibleMoboOutlets={currentIdentity.accessibleMoboOutlets}
              dealerGroupId={currentIdentity.moboDealerGroupId}
            />
          )}
        />
      </Switch>
    </>
  );
}
